import styled from 'styled-components'

export const TimelineInstruction = styled.div`
  > h4 {
    margin-bottom: 0px;
    font-size: 20px;
    
    @media only screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
`

export const TimelineContainer = styled.div`
  padding: 0px 0px;
`

export const TimelineContent = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  ::after {
    content: '';
    position: absolute;
    width: 6px;
    border-left: #000000 2px dashed;
    top: 0px;
    bottom: 0;
    left: 38px;
    margin-left: -3px;
    height: 100%;
  }
  :nth-child(1) {
    > div {
      background: url('https://cld.partsimg.com/image/upload/f_auto,dpr_auto/carparts/lifetime-replacement/printer') no-repeat;
      background-position-y: center;
      z-index: 1;
    }

    ::after {
      top: auto;
      height: 50%;
      bottom: 4px;
    }
  }

  :nth-child(2) {
    > div {
        background: url('https://cld.partsimg.com/image/upload/f_auto,dpr_auto/carparts/lifetime-replacement/truck') no-repeat;
        background-position-y: center;
        z-index: 1;
    }
  }

  :nth-child(3) {
    > div {
      background: url('https://cld.partsimg.com/image/upload/f_auto,dpr_auto/carparts/lifetime-replacement/note') no-repeat;
      background-position-y: center;
      z-index: 1;
    }
    ::after {
      top: 4px;
      height: 50%;
    }
  }
`

export const TimelineBullet = styled.div`
  padding: 10px 0px 10px 40px;
  position: relative;
  background-color: inherit;

  ::after {
    content: '';
    position: absolute;
    width: 70px;
    height: 70px;
    left: -5px;
    background-color: transparent;
    border: none;
    top: 0;
    border-radius: 50%;
    z-index: 1;
  }

  ::before {
    left: 60px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }
`

export const TimelineDetail = styled.div`
  min-height: 90px;
  margin-left: 46px;
  display: flex;
  padding: 20px 0px;

  p {
    margin: 0px;
    color: rgb(51, 51, 51);
    font-size: 16px;
    font-family: 'Roboto';
    font-weight: normal;
    letter-spacing: 0px;
    line-height: 28px;
    display: flex;
    align-self: center;

    > span {
      > span {
        font-weight: bold;
      }
    }

    @media only screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
`
